export default "__VITE_ASSET__BeWdZgSq__"